import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import { isFirstChildAnchor } from "./utils";

export const useOverflowCalc = (Host: HTMLOcButtonV1Element) => {
  let isSpanOverflowingAbortController: AbortController;

  const state = $state({
    /**
 *
 */
    innerSpan: undefined as HTMLElement | undefined,
    /**
 *
 */
    value: false,

    /*                                                                */
    /*                                                                                                   */
    /*                                  */
    computeOverflow: () => {
      /*                                                      */
      isSpanOverflowingAbortController?.abort();
      isSpanOverflowingAbortController = new AbortController();

      /*                                */
      runWithRenderSlice(
        () => {
          /*                       */
          if (!state.innerSpan || state.innerSpan.clientWidth < 1) return;
          const { scrollWidth, clientWidth } = state.innerSpan;

          if (scrollWidth > clientWidth) {
            state.value = true;
            return;
          }

          state.value =
            isFirstChildAnchor(Host.children[0]) && Host.children[0].scrollWidth > clientWidth;
        },
        { signal: isSpanOverflowingAbortController.signal, silent: true },
      );
    },
  });

  return state;
};
